import React from "react";
import TeamCard from "../components/TeamCard";
import "../components/Styles/Team.css";

const Steering = [
  {
    name: "Tanmay Sugandhi",
    role: "President",
    phone: "9492064302",
    year: "ECM 4th year",
    img: "/assets/Board/president.webp",
  },
  {
    name: "Aditi Joshi",
    role: "Vice President",
    phone: "6301932007",
    year: "CSE 3rd year",
    img: "/assets/Board/vice president.webp",
  },
  {
    name: "Rohit Chand R N",
    role: "General Secretary",
    phone: "7036161079",
    year: "CSM 4th year",
    img: "/assets/Board/Gen sec.webp",
  },
  {
    name: "P.Phani Anirudh",
    role: "SAB Chair-Person",
    phone: "9959366367",
    year: "ECE 4th year",
    img: "/assets/Board/sab chair.webp",
  },
];

const Executive = [
  {
    name: "Ch. Manvith",
    role: "Joint Secretary for Technical Affairs",
    phone: "9908219734",
    year: "CSE 3rd year",
    img: "/assets/Board/js tf-1.webp",
  },
  {
    name: "G. Varish Teja",
    role: "Joint Secretary for Technical Affairs ",
    phone: "9059803006",
    year: "ECE 3rd year",
    img: "/assets/Board/js tf-2.webp",
  },
  {
    name: "T. Venkata Prasad",
    role: "Joint Secretary for Management and Development",
    phone: "9182832668",
    year: "AIML 3rd year",
    img: "/assets/Board/js m&d.webp",
  },
  {
    name: "P.Varnan Reddy",
    role: "Joint Secretary for Internal Affairs",
    year: "ECE 3rd year",
    phone: "9392882950",
    img: "/assets/Board/js ia.webp",
  },
  {
    name: "B Induja",
    role: "Joint Secretary for External Affairs",
    year: "CSE 3rd year",
    phone: "7794841239",
    img: "/assets/Board/js ea.webp",
  },
  {
    name: "P Hemanth Kumar",
    role: "Joint Secretary for Organising and Networking",
    year: "ECE 3rd year",
    phone: "8328563007",
    img: "/assets/Board/js O2.webp",
  },
  {
    name: "Devisri Samala",
    role: "Joint Secretary for Organising and Networking",
    year: "ECE 3rd year",
    phone: "7989467820",
    img: "/assets/Board/js O1.webp",
  },
  {
    name: "Siddhi Kinnera",
    role: "Joint Secretary for Designing",
    year: "AIML 3rd year",
    phone: "9000992352",
    img: "/assets/Board/js d1.webp",
  },
  {
    name: "Tanuja Nacham",
    role: "Joint Secretary for Designing",
    year: "DS 3rd year",
    phone: "8096211250",
    img: "/assets/Board/js d2.webp",
  },
  {
    name: "V.Mani Shekar",
    role: "Joint Secretary for Designing",
    year: "ECE 3rd year",
    phone: "9642187707",
    img: "/assets/Board/js d3.webp",
  },
];

const TAB = [
  {
    name: "Sai Varun",
    role: "Chairman",
    phone: "9110347871",
    year: "CSM 4th year",
    img: "/assets/Board/tab chair.webp",
  },
  {
    name: "Parichaya Reddy",
    role: "Head of Computer Vision",
    phone: "9515135304",
    year: "CSE 4th year",
    img: "/assets/Board/CV head.webp",
  },
  {
    name: "G.Geethika",
    role: "Head of Designing",
    phone: "8142158200",
    year: "ECE 4th year",
    img: "/assets/Board/des head.webp",
  },
  {
    name: "Bhanunandhan",
    role: "Head of Embedded",
    phone: "9347222401",
    year: "ECM 4th year",
    img: "/assets/Board/emb head.webp",
  },
  {
    name: "Karthikeya",
    role: "Designing Executive",
    phone: "8328234193",
    year: "ECE 3rd year",
    img: "/assets/Board/des exe.webp",
  },
  {
    name: "Chiranjeevi",
    role: "Designing Executive",
    phone: "6302529167",
    year: "ECE 3rd year",
    img: "/assets/Board/ROS exe.webp",
  },
  {
    name: "Ashish",
    role: "Computer Vision Executive",
    phone: "9014141038",
    year: "CSE 3rd year",
    img: "/assets/Board/dl exe.webp",
  },
  {
    name: "Vaibhavi",
    role: "Computer Vision Executive",
    phone: "8712233166",
    year: "CSE 3rd year",
    img: "/assets/Board/ip exe.webp",
  },
  {
    name: "Thaseen",
    role: "Embedded Executive",
    phone: "8143278865",
    year: "ECE 3rd year",
    img: "/assets/Board/emb exe.webp",
  },
  {
    name: "Nishmitha",
    role: "Embedded Executive",
    phone: "8712265857",
    year: "ECE 3rd year",
    img: "/assets/Board/iot ex.jpg",
  },
];

const CIC = [
  {
    name: "Nomula Dheeraj",
    role: "Chairman",
    phone: "9014052426",
    year: "ECE 4th year",
    img: "/assets/Board/CIC chair.webp"
  },
  {
    name: "T. Nikhil Chowdary",
    role: "Vice Chairman",
    phone: "9063010713",
    year: "IT 4th year",
    img: "/assets/Board/CIC vice chair.webp"
  },
  {
    name: "M. Pradyot Reddy",
    role: "Executive",
    phone: "7386889698",
    year: "CSE 3rd year",
    img: "/assets/Board/CIC exe 1.webp"
  },
  {
    name: "S. Yugendar",
    role: "Executive",
    phone: "8688521080",
    year: "ECE 3rd year",
    img: "/assets/Board/CIC exe 2.webp"
  },
  {
    name: "K. N L Jahnavi",
    role: "Executive",
    phone: "9494124994",
    year: "IOT 3rd year",
    img: "/assets/Board/CIC exe 3.webp"
  }
];


function Team() {
  return (
    <>
      <div className="team-header">
        <h1 className="team-title">Our Team</h1>
      </div>
      <div className="team-section1">
        <h2 className="team-title">Steering Body</h2>
        <div className="team-cards">
          {Steering.map((member, index) => (
            <TeamCard
              key={index}
              img={member.img}
              name={member.name}
              role={member.role}
              phone={member.phone}
              year={member.year}
            />
          ))}
        </div>
      </div>
      <div className="team-section2">
        <h2 className="team-title">Executive Body</h2>
        <div className="team-cards">
          {Executive.map((member, index) => (
            <TeamCard
              key={index}
              img={member.img}
              name={member.name}
              role={member.role}
              phone={member.phone}
              year={member.year}
            />
          ))}
        </div>
      </div>
      <div className="team-section1">
        <h2 className="team-title">Techical Advisory Board</h2>
        <div className="team-cards">
          {TAB.map((member, index) => (
            <TeamCard
              key={index}
              img={member.img}
              name={member.name}
              role={member.role}
              phone={member.phone}
              year={member.year}
            />
          ))}
        </div>
      </div>
      <div className="team-section2">
        <h2 className="team-title">Committee For Incubation & Competence</h2>
        <div className="team-cards">
          {CIC.map((member, index) => (
            <TeamCard
              key={index}
              img={member.img}
              name={member.name}
              role={member.role}
              phone={member.phone}
              year={member.year}
            />
          ))}
        </div>
      </div>
      <div className="break"></div>
    </>
  );
}

export default Team;
